export const SrciButtonSizeEnumsObj = {
  SMALL: "small",
  MEDIUM: "medium",
  BIG: "big",
} as const

export type SrciButtonSizeEnum = typeof SrciButtonSizeEnumsObj[keyof typeof SrciButtonSizeEnumsObj]
